// extracted by mini-css-extract-plugin
export default {"spoilersWrapper":"Spoilers_spoilersWrapper__QHilo","spoilers":"Spoilers_spoilers__2K1qv","hover":"Spoilers_hover__9xRnN","spoilersBody":"Spoilers_spoilersBody__Uhe8s"};